export default __webpack_public_path__ + "static/media/team.160695ea.svg";